// Minimal, tolerant CSV parser (RFC 4180-ish): handles quoted fields, escaped
// quotes (""), commas and newlines inside quotes, and CRLF. Returns rows of raw
// string cells; the caller decides which row is the header.
export function parseCsv(input: string): string[][] {
  // Strip a leading UTF-8 BOM: LinkedIn and Excel exports often include one, and
  // it would otherwise corrupt the first header cell ("﻿First Name").
  const text = input.charCodeAt(0) === 0xfeff ? input.slice(1) : input;
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;
  let started = false;

  const endField = () => {
    row.push(field);
    field = "";
  };
  const endRow = () => {
    endField();
    rows.push(row);
    row = [];
    started = false;
  };

  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    started = true;
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ",") {
      endField();
    } else if (c === "\n") {
      endRow();
    } else if (c !== "\r") {
      field += c;
    }
  }
  if (started || field.length > 0 || row.length > 0) endRow();
  return rows.filter((r) => r.some((cell) => cell.trim() !== ""));
}
